import { MODEL_CATEGORY_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminModelCategoryService = {
  getAll: (params: any) => requests.get(`${MODEL_CATEGORY_URL}`, params),
  create: (params: any) => requests.post(`${MODEL_CATEGORY_URL}`, params),
  updatePosition: (params: any) =>
    requests.patch(`${MODEL_CATEGORY_URL}`, params),
  getSingle: (id: number) => requests.get(`${MODEL_CATEGORY_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.put(`${MODEL_CATEGORY_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${MODEL_CATEGORY_URL}/${id}`),
};
